<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :setLoading="setLoading"
    :persistenceKey="'customer-awaiting-receipt'"
    ref="customer-awaiting-receipt-list"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { FeatureStorage } from "../../_services/storage";
import TransactionListTemplate from "../../templates/transaction-list";
import {
  CustomerTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/customer/customer-tabs";
export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
    };
  },
  async created() {},
  computed: {
    setScreenConfig() {
      var config = {
        title: "Awaiting Receipt",
        ScreenName: "Awaiting Receipt",
        exportFileName: "Awaiting Receipt",
        selectedIndex: GetIndexByTabName("Awaiting Receipt"),
        tabs: CustomerTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "CustomerTransactionHistory",
              filter: [
                [
                  ["CustomerTransactionStatus", "=", "Overdue"],
                  "or",
                  ["CustomerTransactionStatus", "=", "Open"],
                ],
              ],
              serverPaging: true,
              allowGrouping: false,
              remote: true,
            },
            noDataMessage: {},
          },
          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                widget: "dxDropDownButton",
                buttonLocation: "left",
                options: {
                  visible:
                    FeatureStorage.checkPermission("CashReceipt", "create") ||
                    FeatureStorage.checkPermission("Invoice", "create"),
                  icon: "plus",
                  text: "Add New",
                  showArrowIcon: false,
                  keyExpr: "menuText",
                  displayExpr: "menuText",
                  elementAttr: {
                    class: "cx-color-button button-full-width",
                  },
                  dropDownOptions: { width: 120 },
                  items: [
                    {
                      menuText: "Receipt",
                      icon: "plus",
                      onClick: this.onClickReceipt,
                      visible: FeatureStorage.checkPermission(
                        "CashReceipt",
                        "create",
                      ),
                    },
                    {
                      menuText: "Invoice",
                      icon: "plus",
                      onClick: this.onClickInvoice,
                      visible: FeatureStorage.checkPermission(
                        "Invoice",
                        "create",
                      ),
                    },
                  ],
                },
              },
            ],
          },
          columns: [
            {
              screenField: "Code",
              gridDataField: "SalesOrder",
              dataField: "SalesOrder",
              filterLabel: "Sales Order",
              filterDataField: "SalesOrder",
              showInColumnChooser: false,
              visible: false,
              type: "Integer",
              filterIndex: 1,
            },
            {
              screenField: "DateIn",
              filterIndex: 3,
            },
            {
              screenField: "DateCreated",
              filterIndex: 4,
              sortOrder: "desc",
              sortIndex: 0,
              visible: false,
            },
            {
              screenField: "Customer",
              allowHiding: false,
              filterIndex: 6,
            },
            {
              screenField: "CustomerTransactionType",
              width: 75,
            },
            {
              screenField: "DueDate",
              dataField: "InvoiceHeaderDateDue",
              filterIndex: 5,
              width: 80,
              minWidth: 80,
              filterDataField: "InvoiceHeaderDateDue",
            },
            {
              screenField: "CustomerTransactionNumber",
              label: "Transaction",
              width: 75,
              filterIndex: 0,
              hyperlink: {
                url: "",
                gridUrlDataFields: ["CustomerTransactionType", "ICFlag"],
                gridUrlConditions: [
                  {
                    values: [
                      {
                        CustomerTransactionType: "Credit",
                      },
                      {
                        ICFlag: "C",
                      },
                    ],
                    url: "credit-invoice/review/__ID__",
                  },
                  {
                    values: [
                      {
                        CustomerTransactionType: "Credit",
                      },
                      {
                        ICFlag: "I",
                      },
                    ],
                    url: "credit-customer/review/__ID__",
                  },
                  {
                    values: [
                      {
                        CustomerTransactionType: "Invoice",
                      },
                    ],
                    url: "invoice/review/__ID__",
                  },
                  {
                    values: [
                      {
                        CustomerTransactionType: "Receipt",
                      },
                    ],
                    url: "customer-receipt/review/__ID__",
                  },
                  {
                    values: [
                      {
                        CustomerTransactionType: "Unallocated",
                      },
                    ],
                    url: "customer-receipt/review/__ID__",
                  },
                ],
                target: "_blank",
              },
            },
            {
              screenField: "SalesOrder",
              width: 75,
              hyperlink: {
                url: "sales-order/review/__ID__",
                target: "_blank",
              },
            },
            {
              screenField: "CustPO",
              filterIndex: 2,
              type: "Text",
              visible: false,
            },
            {
              screenField: "Currency",
              dataField: "Currency",
              gridDataField: "Currency",
              filterDataField: "Currency",
              width: 70,
              cellTemplate: null,
              exportFields: null,
              filterIndex: 10,
              visible: true,
            },
            {
              screenField: "ExchangeRate",
              dataField: "FXRate",
              gridDataField: "FXRate",
              width: 75,
              label: "FX Rate",
            },
            {
              screenField: "Total",
              label: "Total (Base Currency)",
              subTotal: "SUM",
              grandTotal: "SUM",
            },
            {
              screenField: "FXTotal",
              label: "Total (FX)",
              subTotal: "SUM",
              grandTotal: "SUM",
            },
            {
              screenField: "Allocated",
              subTotal: "SUM",
              grandTotal: "SUM",
              visible: false,
            },
            {
              screenField: "FXAllocated",
              label: "Allocated (FX)",
              subTotal: "SUM",
              grandTotal: "SUM",
              visible: false,
            },
            {
              screenField: "Discount",
              subTotal: "SUM",
              grandTotal: "SUM",
              visible: false,
            },
            {
              screenField: "FXDiscount",
              label: "Discount (FX)",
              subTotal: "SUM",
              grandTotal: "SUM",
              visible: false,
            },
            {
              screenField: "Balance",
              subTotal: "SUM",
              grandTotal: "SUM",
            },
            {
              screenField: "FXBalance",
              label: "Balance (FX)",
              subTotal: "SUM",
              grandTotal: "SUM",
            },
            {
              screenField: "CustomerTransactionStatus",
              // filterIndex: 9,
              // dataSourceConfig: {
              //   data: ["Open", "Overdue"],
              // },
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    onClickReceipt() {
      this.$router.push("customer-receipt/create");
    },
    onClickInvoice() {
      this.$router.push("invoice/create");
    },
  },
};
</script>
<style lang="scss">
.dx-buttongroup-wrapper {
  align-items: center !important;

  .dx-button-text {
    margin-right: 10px !important;
  }
}
</style>
